export default {
  booking_confirmation_title: 'Potvrda rezervacije',
  booking_confirmation_body: 'Hvala Vam za Vašu rezervaciju. Pronađite informacije o potvrdi ispod.',
  location: 'Lokacija',
  pickup_location: 'Mesto preuzimanja',
  dropoff_location: 'Mesto ostavljanja',
  vehicle: 'Vozilo',
  pickup_and_dropoff: 'Vreme preuzimanja i ostavljanja (lokalno vreme)',
  distance_allowance: 'Naknada za udaljenost',
  view_voucher: 'Pogledajte vaučer',
  view_more_bookings: 'Pogledajte više rezervacija',
  identity_verification_body: 'Pre preuzimanja vozila Vi ćete morati da potvrdite svoj identitet',
  identity_verification_title: 'Potvrdite identitet',
  search_again: 'Pretražite ponovo',
  aircon: 'klima',
  refrigeration: 'Pасхлађен',
  not_available: '„Drive &amp; Go“ je trenutno dostupan sa ličnim dokumentima i vozačkim dozvolama iz {profiles}, ali mi konstanto dodajemo više država.',
  check_if_included: 'Proverite je li Vaša država uključena.',
  included_in_booking: 'Uključeno u ovu rezervaciju',
  cdw_with_excess: '„CDW“ osiguranje sa smanjenom odgovornošću',
  theft_protection: 'Osiguranje rizika krađe sa smanjenom odgovornošću',
  risk_reduction: 'Smanjenje rizika',
  free_extras: 'Ovom rezervacijom <br /> imate pravo na dva besplatna dodatka.',
  total_cost: 'Ukupni trošak iznajmljivanja',
  continue: 'Nastavite',
  luggage_large_short_label: '„L“',
  luggage_medium_short_label: '„M“',
  luggage_small_short_label: '„S“',
  luggage_large_long_label: 'veliki',
  luggage_medium_long_label: 'srednji',
  luggage_small_long_label: 'mali',
  fuel_unspecified_label: 'neodređen',
  transmission_manual_label: 'Manuelni menjač',
  transmission_automatic_label: 'Automatski menjač',
  make_a_booking: 'Napravite rezervaciju',
  pickup_date: 'Datum preuzimanja',
  dropoff_date: 'Datum ostavljanja',
  driver_age: 'Vozač između 30 - 65 godina starosti',
  enter_driver_age: 'Unesite godine starosti vozača',
  promo_code: 'Promotivni kod',
  search: 'Pretražite',
  dropoff_date_cannot_be_before_pickup_date: 'Datum ostavljanja ne može biti pre datuma preuzimanja',
  pickup_date_cannot_be_in_the_past: 'Datum preuzimanja ne može biti u prošlosti',
  pickup_time_cannot_be_in_the_past: 'Vreme preuzimanja ne može biti u prošlosti',
  dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'Vreme ostavljanja mora biti posle vremena preuzimanja ako su istog dana',
  vehicle_filters: 'Filteri za vozila',
  reset: 'Ponovo postavite',
  transmission: 'Prenos',
  all: 'Sve',
  manual: 'Manuelni menjač',
  auto: 'Automatski menjač',
  passengers: 'Putnici',
  vehicle_type: 'Tip vozila',
  filter: 'Filter',
  vehicle_search: 'Pretraga vozila',
  edit: 'Uredite',
  no_results: 'Nema rezultata za Vaš kriterijum pretrage',
  small_cars: 'Mali automobili',
  medium_cars: 'Srednji automobili',
  large_cars: 'Veliki automobili',
  estate_cars: 'Karavan automobili',
  suvs: 'Džipovi',
  mpvs: 'Višenamenska vozila',
  vans: 'Kombi vozila',
  camper_vans: 'Kamperi',
  premium: 'Premijum',
  unspecified: 'neodređen',
  large: 'veliki',
  medium: 'srednji',
  small: 'mali',
  automatic: 'automatski menjač',
  you_have_been_refunded: 'Ostvarili ste povrat novca.',
  please_customer_service: 'Da napravite rezervaciju kontaktirajte našu korisničku službu.',
  contact_customer_service: 'Kontaktirajte korisničku službu',
  booking_failed: 'Nije moguće obraditi vašu rezervaciju trenutno.',
  summary: 'Pregled',
  reforestation_and_protection: 'Podržite pošumljavanje i zaštitu prašuma širom Kostarike',
  cost_of_rental: 'Trošak iznajmljivanja',
  to_pay_now: 'Platite sada',
  pay_on_arrival: 'Platite po dolasku',
  greenheart_donation: 'Donacija za zeleno srce',
  tc_agreement: 'Pročitao sam i shvatio {0}.',
  tc: 'Uvjeti i odredbe',
  receive_offers: 'Želeo/la bih da dobijam posebne ponude putem e-pošte.',
  donate: 'Da, želeo/la bih da doniram {amount}',
  pay_now: 'Platite {amount} sada',
  driver_details: 'Podaci o vozaču',
  complete_driver_details: 'Unesite potpune podatke o vozaču.',
  are_you_the_driver: 'Jeste li vi vozač?',
  have_an_account: 'Da li već imate nalog?',
  login: 'Prijavite se',
  or: 'ili',
  first_name: 'Ime vozača',
  last_name: 'Prezime vozača',
  email: 'Adresa e-pošte',
  phone_number: 'Broj mobilnog telefona',
  unable_to_save_driver_information: 'Nije moguće sačuvati podatke o vozaču. Pokušajte ponovo.',
  pay_on_arrival: 'Platite po dolasku',
  pay_online_now: 'Platite sada putem interneta',
  day: 'Dan',
  choose_location: 'Izaberite lokaciju',
  pickup_location: 'Mesto preuzimanja',
  dropoff_location: 'Mesto ostavljanja',
  location_not_found: 'Žao nam je, nismo mogli da pronađemo lokaciju koju ste tražili.',
  add: 'Dodajte',
  remove: 'Uklonite',
  free_extra: 'Besplatni dodaci',
  free: 'BESPLATNO!',
  fast_track_notice: 'Za ovu uslugu važe ograničenja zbog porekla dokumenta. Dostupna je samo osobama sa dokumentima iz',
  complete_booking: 'Završite rezervaciju',
  choose_card: 'Izaberite karticu ili dodajte novu.',
  add_billing_details: 'Dodajte detalje o naplati.',
  card_number: 'Broj kartice',
  card_holder_name: 'Ime vlasnika kartice',
  card_exp: 'MM / GG',
  card_cvc: '„CVC“',
  save_card: 'Da li želite da sačuvate karticu?',
  amount_charged: 'Naplatićemo sa vape kartice',
  payment_confirmation: 'Potvrdite rezervaciju i platite',
  payment_methods: 'dostupni načini plaćanja',
  use_saved_card: 'x koristite sačuvanu karticu',
  use_different_card: '+ koristite drugu karticu',
  book_now: 'Rezervišite sada',
  minimum_age: 'Samo preko {age}',
  excess_liability: 'Smanjenje odgovornosti',
  security_deposit: 'Sigurnosni depozit',
  fuel_policy: 'Politika goriva',
  like_for_like: 'Koliko na početku toliko na kraju',
  full_to_full: 'Sa punim rezervoarom na početku i na kraju',
  miles_per_rental: '{mileage} besplatnih milja po iznajmljivanju',
  km_per_rental: '{mileage} besplatnih kilometara po iznajmljivanju',
  unlimited: 'Neograničeno',
  unlimited_mileage: 'Neograničena miljaža',
  unlimited_mileage_km: 'Neograničena kilometraža',
  non_amendable: 'Ne može se izmeniti',
  non_refundable: 'Ne može se vršiti povrat novca',
  free_cancellation_until: 'Besplatno otkazivanje do',
  cancellation_in_line_with: 'Otkazivanje u skladu sa',
  tcs: 'Uslovima korišćenja',
  free_extras_on_collection: 'Dva besplatna dodatka na naplatu',
  glass_and_tyres_covered: 'Staklo i gume su pokriveni',
  number_of_passengers: 'Broj putnika',
  number_of_bags: 'Broj torbi',
  fuel_type: 'Tip goriva',
  co2: 'CO2',
  aircon: 'Klima',
  book_type: 'Rezervišite {type}',
  processing: 'Obrada',
  actual_price: 'Stvarna cena',
  tooltip: 'Cena u ${currencyCode} je procena na osnovu kursa, cena u ${currency} je obavezujuća.',
  deposit: 'Depozit',
  pay_online: 'Platite sada putem interneta',
  pay_online_without_extras: 'Cena iznajmljivanja',
  extras_on_arrival: 'Dodaci po dolasku',
  insurance_on_arrival: 'Smanjenje rizika - Platite po dolasku',
  insurance_online: 'Smanjenje rizika - Platite sada',
  extras_online: 'Dodatke platite sada',
  green_heart_donation: 'Donacija za zeleno srce',
  aircon_lower: 'клима',
  why_use_drive_and_go: 'Зашто да користите „Drive & Go“?',
  straight_to_car: 'Право у ауто',
  no_queues: 'Без редова чекања',
  self_checkout: 'Самостална одјава',
  cant_lose_key: 'Не можете да изгубите кључ',
  online_id_check: 'Провера идентификација на мрежи',
  phone_as_key: 'Телефон служи као кључ',
  premiumplus_benefits_includes: 'Такође су укључене „Premium Plus+“ погодности',
  book_drive_go: 'Резервишите „Drive & Go“',
  duration: 'Трајање',
  to_pay_on_arrival: 'Платите по доласку',
  return_date: 'Датум повратка',
  my_profile: null,
  additional_options: 'Додатне опције',
  booking_details: 'Детаљи о резервацији',
  price_for_x_days: 'Цена за {qty_of_days} дана | Цена за {qty_of_days} дана',
  cancelled: 'Отказано',
  upcoming: 'Наредно',
  active: 'Активно',
  drive_and_go: {
    drive_and_go: '„Drive And Go“',
    available_countries: '„Drive &amp; Go“ je trenutno dostupan sa ličnim dokumentima i vozačkim dozvolama iz sledećih država:',
    drive_and_go_today: 'Rezervišite „Drive & Go“ danas!',
    drive_and_go_shortened: '„Drive & Go“',
    why_use_drive_and_go: 'Зашто да користите „Drive & Go“?',
    straight_to_car: 'Право у ауто',
    no_queues: 'Без редова чекања',
    self_checkout: 'Самостална одјава',
    cannot_lose_the_key: 'Не можете да изгубите кључ',
    online_id_check: 'Провера идентификација на мрежи',
    phone_as_a_key: 'Телефон служи као кључ',
    premium_plus_benefits_also_included: 'Такође су укључене „Premium Plus+“ погодности',
    book_drive_and_go: 'Резервишите „Drive & Go“'
  },
  my_bookings: "My bookings",
  no_bookings: "No bookings",
  no_bookings_to_display: 'Nema rezervacija za prikaz.',
  search_great_car_rental_deals: "Search great car rental deals for your next trip.",
  odometer_at_collection: 'Merač za pređeni put po preuzimanju',
  fuel_at_collection: 'Gorivo po preuzimanju',
  start_check_in: 'Počnite prijavu',
  start_collection: 'Počnite preuzimanje',
  recent_bookings: 'Nedavne rezervacije',
  damage: {
    updated_damage_report_submitted: 'Dostavljen je ažurirani izveštaj o šteti. Član našeg tima korisničke službe će biti u kontaktu ako bude potrebno.',
    add_additional_damage: 'Dodajte dodatna oštećenja',
    you_may_report_additional_damage_up_to: 'Dodatna oštećenja možete prijaviti do 24 sata nakon odlaska vozila',
    specify_damage: 'Наведите оштећење',
    please_choose_the_area_and_type_of_damage: 'Одаберите подручје и врсту оштећења',
    type_of_damage: 'Врста оштећења',
    is_this_more_than_5_cm: 'Да ли је више од 5 цм?',
    please_take_or_select_a_photo: 'Снимите или одаберите фотографију',
    please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Снимите фотографију да се оштећења јасно виде',
    if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' По потреби можете додати још једну фотографију, одаберите иконицу да бисте додали још једну фотографију',
    save_image: 'Сачувај слику',
    save_images: 'Сачувај слике',
    damage_saved_successfully: 'Оштећење је успешно сачувано',
    add_photo: 'Додај фотографију'
  },
  checkout: {
    start_collection: 'Почни преузимање',
    collect_vehicle: 'Преузми возило',
    we_will_let_you_know_the_details: 'Обавештаваћемо вас о локацији и детаљима како бисте могли да лоцирате возило за изнајмљивање.',
    inspect: 'Прегледај',
    we_will_ask_for_four_photos_from_each_corner: 'Затражићемо четири фотографије из сваког угла возила, заједно са евентуалним новим оштећењима која још нису наведена.',
    fuel_and_milage: 'Гориво и миљажа',
    you_confirm_the_readings_at_the_start_of_your_hire: 'Потврђујете очитавање бројача километара и горива на почетку вашег изнајмљивања.',
    sign: 'Пријава',
    sign_the_rental_agreement: 'Потпишите уговор о изнајмљивању.',
    away_you_go: 'Идите',
    you_are_free_to_take_to_the_road: 'Слободно можете да кренете на пут!',
    collect_your_vehicle: 'Преузмите своје возило',
    get_directions: 'Сазнајте упутства',
    hide_directions: 'Сакриј упутства',
    local_time: 'локално време',
    tel: 'Тел.',
    getting_to_the_location: 'Долазак до локације',
    get_vehicle_details: 'Сазнајте детаље о возилу',
    view_map: 'Погледајте мапу',
    unlock_vehicle_and_continue: 'Откључајте возило и наставите',
    unable_to_connect_to_vehicle: 'Није могуће повезивање са возилом',
    we_were_unable_to_connect_to_the_vehicle_please_check: 'Нисмо успели да се повежемо са возилом - проверите да ли сте поред правог возила и покушајте поново.',
    we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Нисмо могли да нађемо резервацију возила. Покушајте поново касније.',
    odometer_and_fuel: 'Бројач километара и гориво',
    odometer: 'Бројач километара',
    please_confirm_the_odometer_and_fuel_readings: 'Потврдите очитање бројача километара и горива.',
    the_odometer_field_is_required: 'Поље бројача километара је обавезно',
    and_must_be_greater_than_the_checkout_odometer: 'и мора бити већи од миљаже за одјаву',
    confirm: 'Потврдите',
    please_take_a_photo_from_each_corner_of_the_vehicle: 'Фотографишите из сваког угла возила',
    pre_existing_damage: 'Већ постојеће оштећење',
    no_pre_existing_damage: 'Нема већ постојећег оштећења.',
    new_damage: 'Ново оштећење',
    add_additional_damage: 'и додатна оштећења',
    no_new_damage_to_report: 'Нема нових оштећења за пријављивање',
    checkout_complete: 'Одјава је завршена',
    start_rental: 'Почни изнајмљивање',
    congratulations_name_it_is_time_to_take_to_the_road: 'Честитамо {customer_name}, слободно можете да кренете на пут!',
    we_are_unable_to_complete_your_vehicle_checkout: 'Не можемо да довршимо одјаву вашег возила.',
    please_do_the_following: 'Урадите следеће',
    remove_all_belonging_and_lock_the_vehicle: 'Извадите све ствари које вам припадају и закључајте возило.',
    lock_vehicle: 'Закључајте возило',
    once_you_have_contacted_customer_services: 'Једном када контактирате корисничку службу',
    vehicle_location: 'Локација возила',
    collect_your: 'Преузмите своје',
    from: 'Од',
    key_in_glove_box: 'ваш кључ се налази у кутији за рукавице',

    keyholder: {
      not_detected: 'Кључ није откривен у власнику кључева',
      not_detected_please_try_again: 'Ставите свој кључ у држач кључева, а затим покушајте поново.',

      not_installed: 'Држач кључева није инсталиран',
      not_installed_please_contact_customer_service: 'Држач кључева није инсталиран, контактирајте службу за кориснике.',
    },
    keyring: {
      look_up_failed: 'Тражење кључа није успело',
      look_up_failed_please_contact_customer_service: 'Провјера кључева није успјела, контактирајте службу за кориснике.',
    },
    key: {
      invalid: 'Кључ је неважећи',
      invalid_please_contact_customer_service: 'Ваш кључ је неважећи, контактирајте службу за кориснике.',

      expired: 'Кључ је истекао',
      expired__please_contact_customer_service: 'Ваш кључ је истекао, контактирајте службу за кориснике.',
    }
  },
  checkin: {
    tell_us_where_you_have_parked: 'Реците нам где сте паркирали возило.',
    fuel_and_milage: 'Гориво и миљажа',
    you_confirm_the_readings_at_the_end_of_your_hire: 'Потврђујете очитавање бројача километара и горива на крају вашег изнајмљивања.',
    inspect: 'Прегледај',
    we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: 'Затражићемо четири фотографије из сваког угла возила, заједно са евентуалним новим оштећењима током изнајмљивања.',
    lock: 'Закључајте',
    check_you_have_left_no_belonging_then_lock_the_vehicle: 'Проверите да ли нема ствари које вам припадају, а затим закључајте возило.',
    please_tell_us_where_you_have_parked_the_vehicle: 'Реците нам где сте паркирали возило',
    once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Након закључавања возила више га нећете моћи откључати.',
    name_please_check_you_have_left_no_belongings_then_lock_the_vehicle: '{first_name}, проверите да нисте оставили ствари, закључали возило и по потреби вратили физички кључ држачу кључева.',
    lock_vehicle: 'Закључајте возило',
    complete_check_in: 'Завршите пријаву',
    inspection: 'Преглед',
    complete_vehicle_check_in: 'Обавите пријаву возила',
    we_are_unable_to_complete_your_vehicle_check_in: 'Не можемо да довршимо пријаву вашег возила.',
    please_contact_customer_services: 'Контактирајте корисничке службе',
    once_you_have_contacted_customer_services: 'Једном када контактирате корисничку службу'
  },
  rental_agreement: {
    rental_agreement: 'Уговор о изнајмљивању',
    agreement_between: 'Уговор између',
    and: 'и',
    sign_rental_agreement: 'Потпишите уговор о изнајмљивању',
    i_have_read_and_understood_the_terms_and_conditions: 'Pročitao sam i shvatio Uvjeti i odredbe i prihvatio stanje vozila',
  },
  full_insurance_no_deposit: 'Потпуно осигурање и није потребан депозит',
  excess: '{amount} вишак',
  deposit: '{amount} депозит',
  included_daily_distance: '{distance} {unit} дневно',
  miles: 'миља',
  kilometers: 'километара',
  collection_details_title: 'Детаљи колекције',
  collection_details_not_found: 'За ову локацију нису дефинисани детаљи колекције',
  free_cancellation: 'Без икакве накнаде',
  no_deposit: 'Не Депозит',
  benefit_from: 'Корист од',
  for_only_per_day: 'За само {price} дневно',
  upgrade_mee: 'УпградеМее'
}










// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/sr/bookings.js